import React, { useContext, useState, useEffect } from "react";
import { MsalContext } from "../../Contexts/MsalContext";
import InsightReportMatrixViewModel from "../ViewModels/InsightReportMatrixViewModel";
import ReportMatrixBox from "./ReportMatrixBox";
import Box from "@mui/material/Box";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CheckIcon from '@mui/icons-material/Check';
import DashIcon from '@mui/icons-material/HorizontalRule';
interface IInsightAvailability {
    client: string
}
export default function InsightAvailability({ client }: IInsightAvailability) {
    const { msalFetch } = useContext(MsalContext);
    const [channelOptions, setChannelOptions] = useState<string[]>([]);
    const [reportTemplates, setReportTemplates] = useState<InsightReportMatrixViewModel[]>([]);
    const [channel, setChannel] = useState<string>("");

    useEffect(() => {
        setChannel(channelOptions.at(0) ?? "")
    }, [channelOptions])

    useEffect(() => {
        msalFetch(`api/User/GetChannelList?client=${client}`)
            .then(response => response.json())
            .then(json => {
                setChannelOptions(json);
            })
    }, [client])

    useEffect(() => {
        if (channel != undefined && channel != "") {
            msalFetch(`api/Insight/GetReportMatrix?client=${client}&channel=${channel}`)
                .then(response => response.json())
                .then(json => {
                    setReportTemplates(json.value);
                })
        }
    }, [client, channel])

    return (
        <Stack sx={{ overflowY: 'scroll', height: '100%', paddingLeft: 2, paddingRight: 2 }} spacing={2}>

            {/*Description*/}
            <Typography variant="body2" sx={{ paddingTop: 2 }}>
                The below matrix confirms which Insights are currently programmed and therefore available, and which Insights are not yet available, usually due to data volumes. We can currently process approximately 5000 calls at once to produce an Insight and if a time period usually has more than this number of calls, we will not programme the Insight. In the future this limitation will be progressively removed and therefore even the largest channels will have Insights available for the main time periods of Yesterday, WTD and MTD.
            </Typography>

            {/*Channel Dropdown*/}
            <Box>
                <InputLabel>Channel</InputLabel>
                <Select
                    value={channel}
                    onChange={(event) => setChannel(event.target.value)}
                    fullWidth>
                    {channelOptions.map(option =>
                        <MenuItem key={option} value={option}>{option}</MenuItem>)}
                </Select>
            </Box>

            {/*Matrix Grid*/}
            {reportTemplates != undefined && reportTemplates.length > 0 &&
                <TableContainer style={{ overflowX: "initial" }} >
                    <Table stickyHeader>

                        {/*Headers*/}
                        <TableHead>
                            <TableRow>
                                <TableCell align='left' width='55%'>Insight Report Name</TableCell>
                                <TableCell align='center' width='15%'>Daily</TableCell>
                                <TableCell align='center' width='15%'>Weekly</TableCell>
                                <TableCell align='center' width='15%'>Monthly</TableCell>
                            </TableRow>
                        </TableHead>
                        {/*Content*/}
                        <TableBody>
                            {reportTemplates.map((template, index) =>
                                <TableRow
                                    key={template.questionLabel + index}
                                >
                                    <TableCell width='55%' align="left" sx={{ borderRight: '1px solid black' }}>{template.questionLabel}</TableCell>
                                    <TableCell width='15%' padding='none' sx={{ backgroundColor: '#e0e0e04a', borderRight: '1px solid black' }}><ReportMatrixBox hasReport={template.daily} /></TableCell>
                                    <TableCell width='15%' padding='none' sx={{ backgroundColor: '#e0e0e04a', borderRight: '1px solid black' }}><ReportMatrixBox hasReport={template.weekly} /></TableCell>
                                    <TableCell width='15%' padding='none' sx={{ backgroundColor: '#e0e0e04a', borderRight: '1px solid black' }}><ReportMatrixBox hasReport={template.monthly} /></TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        {/*Table Legend*/}
                        <caption>
                            <Box>
                                <CheckIcon color='secondary' fontSize='medium' sx={{ verticalAlign: 'middle' }} /> An Insight is available for this channel in the given Time Period.<br />
                                <DashIcon fontSize='medium' sx={{ verticalAlign: 'middle' }} /> An Insight is not currently available for this channel in the given Time Period.
                            </Box>
                        </caption>

                    </Table>
                </TableContainer>
            }

            {/*Error Message*/}
            {reportTemplates == undefined || reportTemplates.length == 0 &&
                <Box height='100%' alignContent='center' textAlign='center'>
                    Couldn't find any reports for selected channel.
                </Box>
            }
        </Stack>
    );
};
